export const environment = {
    backendUrl: 'https://sales-api.josam.se/',
    production: true,
    projectName: 'josam',
  };
  